export default __webpack_public_path__ + "static/media/IMG_1434.d44d181f.jpg";